module.exports = __webpack_public_path__ + "static/media/admin_img.35ae3963.jpg";